"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudinaryImage1Schema = void 0;
exports.CloudinaryImage1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/cloudinary-image/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "CloudinaryImage1",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:cloudinary-image:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "aspectRatios": {
                    "type": "array",
                    "description": "Cropping advice for specific aspect ratios",
                    "items": {
                        "type": "object",
                        "dependencies": {
                            "imageURL": [
                                "raw"
                            ]
                        },
                        "properties": {
                            "cropping": {
                                "type": "array",
                                "description": "Two coordinates on the image which should be used to crop the desired asepct ratio.",
                                "items": {
                                    "type": "object",
                                    "description": "A coordinate representing a point on the image",
                                    "properties": {
                                        "left": {
                                            "type": "integer",
                                            "description": "Offset from left of raw image",
                                            "minimum": 0
                                        },
                                        "top": {
                                            "type": "integer",
                                            "description": "Offset from top of raw image",
                                            "minimum": 0
                                        }
                                    },
                                    "required": [
                                        "left",
                                        "top"
                                    ]
                                },
                                "maxItems": 2,
                                "minItems": 2
                            },
                            "imageURL": {
                                "type": "string",
                                "description": "Overwrite of the cloudinary URL for a given aspect ratio. Only set if a different image should be used for a given aspect ratio. Replace the '{op}' placeholder with the desired cloudinary image transformation parameters",
                                "pattern": "^https:\\/\\/.+\\/\\{op\\}\\/.+"
                            },
                            "ratio": {
                                "type": "number",
                                "description": "Numerical aspect ratio (width/height)",
                                "minimum": 0
                            },
                            "ratioTextual": {
                                "type": "string",
                                "description": "The cropping ratio in textual form of `{width}x{heigth}`, e.g. 4x3"
                            },
                            "raw": {
                                "type": "object",
                                "description": "The raw dimension of the image. Only set if a different image should be used for a given aspect ratio.",
                                "properties": {
                                    "height": {
                                        "type": "integer"
                                    },
                                    "width": {
                                        "type": "integer"
                                    }
                                },
                                "required": [
                                    "height",
                                    "width"
                                ]
                            }
                        },
                        "required": [
                            "ratio",
                            "ratioTextual"
                        ]
                    },
                    "minItems": 1
                },
                "imageURL": {
                    "type": "string",
                    "description": "The cloudinary URL to the image. Replace the `{op}` placeholder with the desired cloudinary image transformation parameters",
                    "pattern": "^https:\\/\\/.+\\/\\{op\\}\\/.+"
                },
                "predominantColors": {
                    "type": "array",
                    "description": "Predominant colors of the image. Can be used to highlight some overlaying text.",
                    "items": {
                        "type": "object",
                        "description": "The predominant color object - A combination of a hex color code and the percentage value of the color in the image.",
                        "properties": {
                            "hexColorCode": {
                                "type": "string",
                                "pattern": "#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$"
                            },
                            "percentage": {
                                "type": "number"
                            }
                        },
                        "required": [
                            "hexColorCode",
                            "percentage"
                        ]
                    }
                },
                "raw": {
                    "type": "object",
                    "description": "The raw dimension of the image",
                    "properties": {
                        "height": {
                            "type": "integer"
                        },
                        "width": {
                            "type": "integer"
                        }
                    },
                    "required": [
                        "height",
                        "width"
                    ]
                },
                "trimmedDimensions": {
                    "type": "object",
                    "description": "The dimensions of the image after removing the edges around the image (e.g. removing the whitespace around the image, see https://cloudinary.com/cookbook/trim_photo_background). This trimmed dimensions allows for accurate positioning and scaling, particularly useful when the image is used as a logo or embedded within other visual elements.",
                    "properties": {
                        "height": {
                            "type": "integer"
                        },
                        "width": {
                            "type": "integer"
                        }
                    }
                },
                "imageFormat": {
                    "type": "string",
                    "description": "Defines the image file format (e.g., JPG, PNG, GIF), indicating how the image is encoded."
                }
            },
            "required": [
                "imageURL",
                "raw"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,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